export enum operatorFilterActives {
  All = "All",
  active = "Active",
  inActive = "In Active"
}
